<template>
    <div class="sidebar-box">
        <slot />
    </div>
</template>

<style scoped lang="scss">
    .sidebar-box {
        box-sizing: border-box;
        padding: var(--joy-core-spacing-8);
        background-color: var(--joy-color-background-default);
        border-radius: var(--joy-core-radius-3);
        position: relative;
        border: 1px solid var(--joy-color-neutral-30);
        font-family: var(--joy-font-family-base);
        margin-bottom: var(--joy-core-spacing-5);
    }
</style>
